import { Controller } from "stimulus";

/**
 * Signed-out users who click a sign-up link see the LinkedIn explanation
 * modal instead of navigating to the sign-up page.
 */
export default class LinkedinSignupController extends Controller {
  intercept(event) {
    const link = event.target.closest("a[href]");
    if (!link || !link.href.endsWith("sign-up")) return;

    event.preventDefault();
    MicroModal.show(this.element.id, { disableFocus: true });
  }
}
